import http from '@/libs/axios'

export const farmManager = {
  namespaced: true,
  state: {
    farmsPage: {
      data: [],
      total_rows: 0,
      current_page: 1,
      per_page: 12,
    },
    productionPage: {
      data: [],
      total_rows: 0,
      current_page: 1,
      per_page: 10,
    },
    currentFarm: null,
    farmSummary: null,
    farmerMatches: [],
  },
  mutations: {
    setFarmsPage(state, page) {
      state.farmsPage = page
    },
    setProductionPage(state, page) {
      state.productionPage = page
    },
    setCurrentFarm(state, payload) {
      state.currentFarm = payload?.farm || null
      state.farmSummary = payload?.summary || null
    },
    setFarmerMatches(state, matches) {
      state.farmerMatches = matches
    },
  },
  actions: {
    fetchFarms({ commit }, query = {}) {
      const params = new URLSearchParams({
        search: query.search || '',
        page: query.page || 1,
        per_page: query.per_page || 12,
        member_id: query.member_id || '',
      })
      return http.get(`farm-manager/farms?${params.toString()}`).then(res => {
        commit('setFarmsPage', res.data)
        return res.data
      })
    },
    fetchFarm({ commit }, id) {
      return http.get(`farm-manager/farms/${id}`).then(res => {
        commit('setCurrentFarm', res.data)
        return res.data
      })
    },
    createFarm(_, data) {
      return http.post('farm-manager/farms', data).then(res => res.data)
    },
    updateFarm(_, { id, data }) {
      return http.post(`farm-manager/farms/${id}`, data).then(res => res.data)
    },
    deleteFarm(_, id) {
      return http.delete(`farm-manager/farms/${id}`)
    },
    searchFarmers({ commit }, { search, limit = 5 }) {
      return http.get(`farm-manager/farmer-search?search=${encodeURIComponent(search || '')}&limit=${limit}`)
        .then(res => {
          commit('setFarmerMatches', res.data)
          return res.data
        })
    },
    fetchProduction({ commit }, query = {}) {
      const params = new URLSearchParams({
        search: query.search || '',
        page: query.page || 1,
        per_page: query.per_page || 10,
      })
      return http.get(`farm-manager/production?${params.toString()}`).then(res => {
        commit('setProductionPage', res.data)
        return res.data
      })
    },
    createYield(_, { farmId, data }) {
      return http.post(`farm-manager/farms/${farmId}/yields`, data).then(res => res.data)
    },
    updateYield(_, { yieldId, data }) {
      return http.post(`farm-manager/yields/${yieldId}`, data).then(res => res.data)
    },
    deleteYield(_, yieldId) {
      return http.delete(`farm-manager/yields/${yieldId}`)
    },
  },
  getters: {
    farms: state => state.farmsPage.data || [],
    farmsTotal: state => state.farmsPage.total_rows || 0,
    productionRows: state => state.productionPage.data || [],
    productionTotal: state => state.productionPage.total_rows || 0,
    currentFarm: state => state.currentFarm,
    farmSummary: state => state.farmSummary,
    farmerMatches: state => state.farmerMatches,
  },
}
